import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProductCard = ({ product }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })?.format(price);
  };

  return (
    <div className="bg-card rounded-lg shadow-soft hover:shadow-medium transition-all duration-300 overflow-hidden group">
      {/* Product Image */}
      <div className="relative overflow-hidden aspect-square">
        <Image
          src={product?.image}
          alt={product?.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {product?.isNew && (
          <div className="absolute top-3 left-3 bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-medium">
            New
          </div>
        )}
        {product?.discount && (
          <div className="absolute top-3 right-3 bg-error text-error-foreground px-2 py-1 rounded-full text-xs font-medium">
            -{product?.discount}%
          </div>
        )}
        
        {/* Quick Actions */}
        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center space-x-2">
          <Button variant="secondary" size="icon" className="bg-background/90 hover:bg-background">
            <Icon name="Heart" size={16} />
          </Button>
          <Button variant="secondary" size="icon" className="bg-background/90 hover:bg-background">
            <Icon name="Eye" size={16} />
          </Button>
        </div>
      </div>
      {/* Product Info */}
      <div className="p-4">
        <div className="mb-2">
          <span className="text-xs text-muted-foreground uppercase tracking-wide font-medium">
            {product?.category}
          </span>
        </div>
        
        <h3 className="text-lg font-semibold text-foreground mb-2 line-clamp-2">
          {product?.name}
        </h3>
        
        <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
          {product?.description}
        </p>
        
        {/* Price and Rating */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            {product?.originalPrice && (
              <span className="text-sm text-muted-foreground line-through">
                {formatPrice(product?.originalPrice)}
              </span>
            )}
            <span className="text-lg font-bold text-foreground">
              {formatPrice(product?.price)}
            </span>
          </div>
          
          {product?.rating && (
            <div className="flex items-center space-x-1">
              <Icon name="Star" size={14} className="text-warning fill-current" />
              <span className="text-sm text-muted-foreground">
                {product?.rating} ({product?.reviews})
              </span>
            </div>
          )}
        </div>

        {/* Size Options */}
        {product?.sizes && (
          <div className="mb-3">
            <div className="flex flex-wrap gap-1">
              {product?.sizes?.slice(0, 4)?.map((size) => (
                <span
                  key={size}
                  className="px-2 py-1 text-xs border border-border rounded text-muted-foreground"
                >
                  {size}
                </span>
              ))}
              {product?.sizes?.length > 4 && (
                <span className="px-2 py-1 text-xs text-muted-foreground">
                  +{product?.sizes?.length - 4} more
                </span>
              )}
            </div>
          </div>
        )}

        {/* Add to Cart Button */}
        <Button style={{ visibility: 'hidden' }}
          variant="default"
          fullWidth
          iconName="ShoppingBag"
          iconPosition="left"
          className="mt-2"
        >
          Add to Cart
        </Button>
      </div>
    </div>
  );
};

export default ProductCard;